export default {"src":"/_next/static/media/easyearn.374d73ae.svg","height":776,"width":1106,"blurWidth":0,"blurHeight":0};